import { useMutation, useQueryClient } from '@tanstack/react-query'
import { logout } from 'api'
import { useAuthContext } from 'app/auth'
import { paths } from 'app/routes'
import { Button } from 'elements/inputs/button'
import { Menu } from 'elements/navigation'
import { LinkButton } from 'elements/navigation/link'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type ProfileNavigationMenuProps = {
  open: boolean
  anchorEl: HTMLButtonElement | null
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>
  id?: string
}

export const ProfileNavigationMenu = ({
  open,
  anchorEl,
  setAnchorEl,
  id,
}: ProfileNavigationMenuProps) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const queryClient = useQueryClient()

  const { unauthorize } = useAuthContext()

  const $logout = useMutation(logout)

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const buttonStyles = {
    p: 2,
    justifyContent: 'left',
    width: '100%',
    borderRadius: 0,
  }

  return (
    <Menu
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={closeMenu}
      width="200px"
    >
      <LinkButton
        to={paths.profileSettings}
        variant="text"
        sx={buttonStyles}
        onClick={closeMenu}
      >
        {t('common.my_profile')}
      </LinkButton>

      <LinkButton
        to={paths.settings}
        variant="text"
        sx={buttonStyles}
        onClick={closeMenu}
      >
        {t('common.settings')}
      </LinkButton>

      <LinkButton
        to={paths.plans}
        variant="text"
        sx={buttonStyles}
        onClick={closeMenu}
      >
        {t('common.plans')}
      </LinkButton>

      <LinkButton
        to={paths.payments}
        variant="text"
        sx={buttonStyles}
        onClick={closeMenu}
      >
        {t('common.payments')}
      </LinkButton>

      <Button
        variant="text"
        onClick={() => {
          $logout.mutate(undefined, {
            onSuccess: () => {
              unauthorize()
              queryClient.removeQueries()
              navigate(paths.signIn)
            },
          })
          closeMenu()
        }}
        sx={buttonStyles}
      >
        {t('common.log_out')}
      </Button>
    </Menu>
  )
}
